// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable react/no-danger */
import React from 'react';
import { string } from 'prop-types';
import { NAVIGATION_START } from '@tcp/core/src/constants/rum.constants';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import { usePerfMark, usePerfMeasure } from '../../../../hooks/performance';

const isEnabled = Boolean(process.env.PERF_TIMING);

function ServerOnlyScript({ children, ...props }) {
  const hasMounted = useHasMounted();
  // This may be unnecessary since react-dom will not execute the contents.
  return (
    <script
      suppressHydrationWarning
      {...props}
      dangerouslySetInnerHTML={{ __html: !hasMounted ? children : null }}
    />
  );
}

ServerOnlyScript.propTypes = {
  children: string.isRequired,
};

export function Mark({ name }) {
  // For client-side execution
  usePerfMark(name);
  // For server-side execution
  return isEnabled ? (
    <ServerOnlyScript>{`typeof performance !== ${'undefined'} && performance.mark('${name}');`}</ServerOnlyScript>
  ) : null;
}

Mark.propTypes = {
  name: string.isRequired,
};

export function Measure({ name, start, end, timerName, cdGroup }) {
  // For client-side execution
  // Note: use `NAVIGATION_START` as a default for CSR user timing
  usePerfMeasure(name, start || NAVIGATION_START, end, timerName, cdGroup);
  // For server-side execution
  return isEnabled ? (
    <ServerOnlyScript>
      {/* "start" and "end" intentionally omitted for SSR */}
      {`typeof performance !== ${'undefined'} && performance.measure('${name}');`}
    </ServerOnlyScript>
  ) : null;
}

Measure.propTypes = {
  name: string.isRequired,
  start: string,
  end: string,
  timerName: string,
  cdGroup: string,
};

Measure.defaultProps = {
  start: undefined,
  end: undefined,
  timerName: '',
  cdGroup: '',
};

export default {
  Mark,
  Measure,
};
